// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.route-panel {
  font-size: 14px;
  line-height: 20px;
  filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1)),
    drop-shadow(2px 0px 36px rgba(0, 0, 0, 0.07));
  background: #ffffff;
}

  .route-panel .spin-route {
    margin-top: 20%;
    margin-left: 45%;
  }

  .route-panel .route-form {
    display: flex;
    padding: 0px 20px 0px;
  }

  .route-panel .route-field {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px 20px 20px;
  }

  .route-panel .route-field .active path {
      fill: #ff6767;
    }

  .route-panel .route-input {
    width: 290px;
  }

  .route-panel .toggle {
    font-size: 20px;
    margin-right: 10px;
  }

  .route-panel .route-menu {
    padding-top: 10px;
    line-height: 30px;
    justify-content: flex-end;
  }

  .route-panel .route-error {
    margin-top: 20px;
  }

  .route-panel .route-button {
    display: flex;
    margin-bottom: 0px;
  }

  .route-panel .route-button button {
      height: 40px;
      color: #91919e;
      font-family: Golos UI;
      font-size: 12px;
      line-height: 24px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }

  @media screen and (max-width: 1024px) {
    .route-panel .route-panel {
      top: 70px;
      height: 640px;
    }
  }

  @media screen and (max-width: 768px) {
    .route-panel .route-panel {
      top: 510px !important;
    }
  }

.route-content .route-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
  }

.route-content .content-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
  }

.route-content .content-header div {
      font-size: 16px;
    }

.route-content .content-header span {
      color: #91919e;
      font-weight: 600;
    }

.route-content .content-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
  }

.route-content .content-body .content-icon {
      width: 50px;
    }

.route-content .content-body .content-icon svg {
        font-size: 20px;
      }

.route-content .content-body .content-time {
      width: 70px;
      text-align: right;
    }

.route-content .content-body:hover {
    background: #edf1ff;
  }

.route-content .content-body-title {
    width: 240px;
    text-align: left;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Module/Route/style.scss"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;iDAC+C;EAC/C,mBAAkB;AAsEpB;;EApEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;EAK7B;;EAHE;MACE,aAAY;IACd;;EAGF;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;EAWpB;;EATE;MACE,YAAY;MACZ,cAAsB;MACtB,qBAAqB;MACrB,eAAe;MACf,iBAAiB;MACjB,qBAAqB;MACrB,yBAAyB;IAC3B;;EAGF;IACE;MACE,SAAS;MACT,aAAa;IACf;EACF;;EAEA;IACE;MACE,qBAAqB;IACvB;EACF;;AAIA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;EAChB;;AACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EAUpB;;AARE;MACE,eAAe;IACjB;;AAEA;MACE,cAAsB;MACtB,gBAAgB;IAClB;;AAGF;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EAcjB;;AAZE;MACE,WAAW;IAKb;;AAHE;QACE,eAAe;MACjB;;AAGF;MACE,WAAW;MACX,iBAAiB;IACnB;;AAGF;IACE,mBAAiC;EACnC;;AAEA;IACE,YAAY;IACZ,gBAAgB;EAClB","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.route-panel {\n  font-size: 14px;\n  line-height: 20px;\n  filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1)),\n    drop-shadow(2px 0px 36px rgba(0, 0, 0, 0.07));\n  background: $white;\n\n  .spin-route {\n    margin-top: 20%;\n    margin-left: 45%;\n  }\n\n  .route-form {\n    display: flex;\n    padding: 0px 20px 0px;\n  }\n\n  .route-field {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px 20px 20px 20px;\n\n    .active path {\n      fill: $peach;\n    }\n  }\n\n  .route-input {\n    width: 290px;\n  }\n\n  .toggle {\n    font-size: 20px;\n    margin-right: 10px;\n  }\n\n  .route-menu {\n    padding-top: 10px;\n    line-height: 30px;\n    justify-content: flex-end;\n  }\n\n  .route-error {\n    margin-top: 20px;\n  }\n\n  .route-button {\n    display: flex;\n    margin-bottom: 0px;\n\n    button {\n      height: 40px;\n      color: $black-disabled;\n      font-family: Golos UI;\n      font-size: 12px;\n      line-height: 24px;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n    }\n  }\n\n  @media screen and (max-width: 1024px) {\n    .route-panel {\n      top: 70px;\n      height: 640px;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    .route-panel {\n      top: 510px !important;\n    }\n  }\n}\n\n.route-content {\n  .route-body {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow: auto;\n  }\n  .content-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 24px;\n\n    div {\n      font-size: 16px;\n    }\n\n    span {\n      color: $black-disabled;\n      font-weight: 600;\n    }\n  }\n\n  .content-body {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 10px 18px;\n    cursor: pointer;\n\n    .content-icon {\n      width: 50px;\n\n      svg {\n        font-size: 20px;\n      }\n    }\n\n    .content-time {\n      width: 70px;\n      text-align: right;\n    }\n  }\n\n  .content-body:hover {\n    background: $highlight-light-blue;\n  }\n\n  .content-body-title {\n    width: 240px;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
